// extracted by mini-css-extract-plugin
export default {"li":"loading_li__w-ydA","pulse":"loading_pulse__2QNit"};